import React from 'react';
import { cn } from '@/lib/utils';

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  as?: 'section' | 'div' | 'article' | 'main';
  title?: string;
  subtitle?: string;
  tight?: boolean;
}

const Section: React.FC<SectionProps> = ({
  as: Tag = 'section',
  title,
  subtitle,
  tight,
  className,
  children,
  ...props
}) => (
  <Tag
    className={cn('w-full', !tight && 'py-12', className)}
    {...props}
  >
    {(title || subtitle) && (
      <div className="mb-8 text-center">
        {title && <h2 className="text-3xl font-bold text-gray-900 mb-2">{title}</h2>}
        {subtitle && <p className="text-gray-500 text-base max-w-xl mx-auto">{subtitle}</p>}
      </div>
    )}
    {children}
  </Tag>
);

export { Section };
export type { SectionProps };
